module.exports = __webpack_public_path__ + "static/img/img_logo.cf2f94cd.png";